import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'ru',
  months: [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря',
  ],
  monthsShort: ['янв', 'февр', 'мар', 'апр', 'мая', 'июн', 'июл', 'авг', 'сент', 'окт', 'нояб', 'дек'],
  weekdays: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
  weekdaysMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  weekdaysShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'DD.MM.YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd, D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd, D MMMM HH:mm',
    l: 'D.M.YYYY',
    'l-Y': 'D.M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM YYYY HH:mm',
    'lll-Y': 'D MMM HH:mm',
    llll: 'ddd, D MMM YYYY HH:mm',
    'llll-Y': 'ddd, D MMM HH:mm',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY, HH:mm ([GMT]Z)',
  },
  past: {
    y: { one: '%s г. назад', few: '%s г. назад', many: '%s л. назад', other: '%s г. назад' },
    M: { one: '%s мес. назад', few: '%s мес. назад', many: '%s мес. назад', other: '%s мес. назад' },
    w: { one: '%s нед. назад', few: '%s нед. назад', many: '%s нед. назад', other: '%s нед. назад' },
    d: { one: '%s дн. назад', few: '%s дн. назад', many: '%s дн. назад', other: '%s дн. назад' },
    h: { one: '%s ч назад', few: '%s ч назад', many: '%s ч назад', other: '%s ч назад' },
    m: { one: '%s мин. назад', few: '%s мин. назад', many: '%s мин. назад', other: '%s мин. назад' },
    s: { one: '%s сек. назад', few: '%s сек. назад', many: '%s сек. назад', other: '%s сек. назад' },
  },
  future: {
    y: { one: 'через %s г.', few: 'через %s г.', many: 'через %s л.', other: 'через %s г.' },
    M: { one: 'через %s мес.', few: 'через %s мес.', many: 'через %s мес.', other: 'через %s мес.' },
    w: { one: 'через %s нед.', few: 'через %s нед.', many: 'через %s нед.', other: 'через %s нед.' },
    d: { one: 'через %s дн.', few: 'через %s дн.', many: 'через %s дн.', other: 'через %s дн.' },
    h: { one: 'через %s ч', few: 'через %s ч', many: 'через %s ч', other: 'через %s ч' },
    m: { one: 'через %s мин.', few: 'через %s мин.', many: 'через %s мин.', other: 'через %s мин.' },
    s: { one: 'через %s сек.', few: 'через %s сек.', many: 'через %s сек.', other: 'через %s сек.' },
  },
  abbr: {
    y: { one: '%s г', few: '%s г', many: '%s лет', other: '%s г' },
    M: { one: '%s мес', few: '%s мес', many: '%s мес', other: '%s мес' },
    w: { one: '%s нед', few: '%s нед', many: '%s нед', other: '%s нед' },
    d: { one: '%s дн', few: '%s дн', many: '%s дн', other: '%s дн' },
    h: { one: '%s ч', few: '%s ч', many: '%s ч', other: '%s ч' },
    m: { one: '%s мин', few: '%s мин', many: '%s мин', other: '%s мин' },
    s: { one: '%s с', few: '%s с', many: '%s с', other: '%s с' },
  },
  justNow: 'только что',
  yesterday: 'Вчера',
  today: 'Сегодня',
  tomorrow: 'Завтра',
  weekStart: 1,
};
const localeName: LocaleName = 'ru';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (): string => '',
};
